import "./v2-question-surface.css";

export default function QuestionCounter({ current, total }) {
  return (
    <div className="tgc-v2-counter">
      Question {current} of {total}
    </div>
  );
}
